"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuadEventTargetProvider = void 0;
const hit_test_result_1 = require("../../hit-testing/hit-test-result");
const quad_element_shared_object_1 = require("../../hit-testing/shared-quad-tree/quad-element-shared-object");
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Wrapper of {@link ISharedEntityQuadTree}, maps pointer events to entities.
 */
class QuadEventTargetProvider {
    constructor(hitTestableGroup, quadTree) {
        this.hitTestableGroup = hitTestableGroup;
        this.quadTree = quadTree;
    }
    hitTestPlot(pointerEvent) {
        const updateArg = this.quadTree.hitTestArg;
        if (updateArg == null) {
            // Possible for queries to come in during the initial rollup period
            return rc_js_util_1._Array.emptyArray;
        }
        const hitTestableGroup = this.hitTestableGroup;
        const resultCount = this.quadTree.sharedTree.queryPoint(pointerEvent.pointerCssPosition, hitTestableGroup.groupMask);
        const entities = this.quadTree.entities;
        const quadTreeResults = this.quadTree.sharedTree.getResults();
        const hitTestResults = new Map();
        for (let i = 0, iEnd = resultCount * quad_element_shared_object_1.QuadElementSharedObject.elementCount; i < iEnd; i += quad_element_shared_object_1.QuadElementSharedObject.elementCount) {
            const entity = entities[quadTreeResults[i]];
            DEBUG_MODE && rc_js_util_1._Debug.assert(entity != null, "failed entity lookup");
            if (!hitTestableGroup.isEntityInGroup(entity)) {
                // it's possible that the entity was removed from the group after the tree was created
                // invalidating the tree for a removal would be needlessly expensive (regenerate), so just filter them out
                continue;
            }
            const isHitAllowed = hitTestableGroup.hitAllowedComponentStore
                .getComponent(entity)
                .isHitAllowed(entity, pointerEvent, updateArg);
            if (!isHitAllowed) {
                continue;
            }
            const dataId = quadTreeResults[i + 1];
            const isHit = hitTestableGroup.hitTestableGroup
                .getHitTester(entity)
                .hitTest(entity, dataId, pointerEvent.pointerCssPosition, updateArg);
            if (!isHit) {
                continue;
            }
            const hitTestResult = hitTestResults.get(entity);
            if (hitTestResult == null) {
                const segments = new Set();
                segments.add(dataId);
                hitTestResults.set(entity, new hit_test_result_1.HitTestResult(entity, segments, updateArg, quadTreeResults[i + 2]));
            }
            else {
                hitTestResult.segmentIds.add(dataId);
            }
        }
        return rc_js_util_1._Map.valuesToArray(hitTestResults);
    }
}
exports.QuadEventTargetProvider = QuadEventTargetProvider;
//# sourceMappingURL=quad-event-target-provider.js.map